/**
 * Horizontal step indicator for the deployment wizard.
 */
interface Step {
  label: string
  completed: boolean
}

interface WizardStepsProps {
  currentStep: 1 | 2 | 3 | 4
  steps: Step[]
}

export function WizardSteps({ currentStep, steps }: WizardStepsProps) {
  return (
    <nav aria-label="Progress" className="mb-8">
      <ol className="flex items-center justify-between">
        {steps.map((step, index) => {
          const stepNumber = index + 1
          const isActive = stepNumber === currentStep
          const isCompleted = step.completed

          return (
            <li key={step.label} className="flex-1 relative">
              {/* Connector line */}
              {index > 0 && (
                <div
                  className={`absolute left-0 top-4 -translate-y-1/2 w-full h-0.5 -ml-1/2 ${
                    steps[index - 1].completed ? 'bg-primary-600' : 'bg-gray-200'
                  }`}
                  style={{ width: 'calc(100% - 2rem)', marginLeft: '-50%' }}
                />
              )}

              <div className="flex flex-col items-center relative">
                {/* Step circle */}
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium border-2 transition-colors ${
                    isCompleted
                      ? 'bg-primary-600 border-primary-600 text-white'
                      : isActive
                      ? 'bg-white border-primary-600 text-primary-600'
                      : 'bg-white border-gray-300 text-gray-500'
                  }`}
                >
                  {isCompleted ? (
                    <CheckIcon className="w-5 h-5" />
                  ) : (
                    stepNumber
                  )}
                </div>

                {/* Step label */}
                <span
                  className={`mt-2 text-xs font-medium ${
                    isActive ? 'text-primary-600' : 'text-gray-500'
                  }`}
                >
                  {step.label}
                </span>
              </div>
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

function CheckIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
    </svg>
  )
}
